import XLSX from 'sheetjs-style';

const exportXlsx = (itemValues, colHeaders, type, project) => {
  const s = {
    border: {
      top: { style: 'thin', color: { auto: 1 } },
      right: { style: 'thin', color: { auto: 1 } },
      bottom: { style: 'thin', color: { auto: 1 } },
      left: { style: 'thin', color: { auto: 1 } },
    },
  };
  const hs = {
    ...s,
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    font: {
      bold: true,
    },
  };
  const h1 = {
    alignment: { horizontal: 'center', vertical: 'top', wrapText: true },
    font: {
      sz: 14,
      bold: true,
    },
  };

  const dataHeader = {};
  colHeaders.forEach((hd) => {
    let fieldName = ` ${hd}`;
    const fieldData = ` ${hd}`;
    if (hd === 'Tên') {
      fieldName = 'name';
    }
    dataHeader[fieldName] = { v: fieldData, s: hs };
  });

  const data2 = [
    {
      name: {
        v: project.name,
        s: h1,
      },
    },
    dataHeader,
  ];

  const data = itemValues.map((item) => {
    const dataValue = {};
    colHeaders.forEach((hd) => {
      let fieldName = ` ${hd}`;
      if (hd === 'Tên') fieldName = 'name';
      dataValue[fieldName] = { v: item[fieldName], s };
    });
    return dataValue;
  });

  const ws = XLSX.utils.json_to_sheet(data2.concat(data), { skipHeader: true });
  const wscols = [
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
  ];
  ws['!cols'] = wscols;
  ws['!rows'] = [{ hpx: 30 }, { hpx: 30 }];

  let rowMerge = 24;
  if (type === 'monthly') {
    rowMerge = 31;
  } else if (type === 'yearly') {
    rowMerge = 12;
  }
  const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: rowMerge } }];
  ws['!merges'] = merge;

  const wb = { Sheets: { 'Sheet 1': ws }, SheetNames: ['Sheet 1'] };
  const excelBuffer = XLSX.write(wb, {
    bookType: 'xlsx',
    cellStyles: true,
    skipHeader: true,
    type: 'array',
  });
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const blob = new Blob([excelBuffer], { type: fileType });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${project.name}.xlsx`;
  link.click();
};

export default exportXlsx;
